import { Users, MapPin, Shield, BookOpen, Hourglass, Heart, PawPrint } from "lucide-react";

export const CATEGORIES = [
  { key: "Characters", icon: Users, text: "text-amber-400", bg: "bg-amber-500/10", border: "border-amber-500/30", hex: "#f59e0b" },
  { key: "Species", icon: PawPrint, text: "text-sky-400", bg: "bg-sky-500/10", border: "border-sky-500/30", hex: "#38bdf8" },
  { key: "Locations", icon: MapPin, text: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30", hex: "#10b981" },
  { key: "Factions", icon: Shield, text: "text-purple-400", bg: "bg-purple-500/10", border: "border-purple-500/30", hex: "#a855f7" },
  { key: "Lore", icon: BookOpen, text: "text-cyan-400", bg: "bg-cyan-500/10", border: "border-cyan-500/30", hex: "#06b6d4" },
  { key: "Events", icon: Hourglass, text: "text-rose-400", bg: "bg-rose-500/10", border: "border-rose-500/30", hex: "#f43f5e" },
  { key: "Ships", icon: Heart, text: "text-pink-400", bg: "bg-pink-500/10", border: "border-pink-500/30", hex: "#ec4899" },
];

export const catMeta = (key) => CATEGORIES.find((c) => c.key === key) || CATEGORIES.find((c) => c.key === "Lore");

export const REL_TYPES = {
  ally: "#10b981",
  enemy: "#ef4444",
  family: "#f59e0b",
  romance: "#ec4899",
  rival: "#a855f7",
  mentor: "#06b6d4",
  friend: "#60a5fa",
  ship: "#f472b6",
  other: "#94a3b8",
};

export const CHARACTER_PRESETS = [
  { title: "Biographical Information", short: "Biographical", facts: ["Full Name", "Status", "Gender", "Sexuality", "Birthday", "Age", "Marital Status", "Species", "Education", "Occupation", "Nicknames"] },
  { title: "Physical Appearance", short: "Appearance", facts: ["Height", "Hair Color", "Eye Color", "Piercings", "Tattoos", "Scars", "Portrayal"] },
  { title: "Relationships", short: "Relationships", facts: ["Romances", "Family", "Friends", "Allies", "Enemies"] },
  { title: "Series Information", short: "Series", facts: ["Character Type"] },
];

export const SHIP_PRESET = { title: "Ship Information", short: "Ship", facts: ["Characters", "Ship Name", "Alternate Names", "Ship Type", "Status"] };
export const SPECIES_PRESETS = [
  { title: "Species Information", short: "Species", facts: ["Other Names", "Status", "Sapient", "Lifespan", "Origin", "Related Species"] },
  { title: "Biology", short: "Biology", facts: ["Average Height", "Distinguishing Features", "Diet", "Habitat"] },
];
export const SPECIES_STATUSES = {
  Extant: { cls: "text-emerald-200 bg-emerald-500/15 border-emerald-500/40", hex: "#34d399" },
  Endangered: { cls: "text-amber-200 bg-amber-500/15 border-amber-500/40", hex: "#f59e0b" },
  Extinct: { cls: "text-stone-300 bg-stone-500/15 border-stone-500/40", hex: "#a8a29e" },
};
// [value, editor label, how the source shows on the linked page, how the linked species shows on the source page]
export const SPECIES_RELATIONS = [
  ["subspecies", "Subspecies of", "Subspecies", "Parent species"],
  ["ancestor", "Ancestor of", "Ancestor", "Descendant"],
  ["descendant", "Descendant of", "Descendant", "Ancestor"],
  ["hybrid", "Hybrid of", "Hybrid offspring", "Hybrid parent"],
  ["cousin", "Cousin species of", "Cousin species", "Cousin species"],
  ["other", "Other", "Other", "Other"],
];
export const LIFESPAN_UNITS = ["days", "months", "years", "decades", "centuries", "millennia"];

export const SHIP_TYPES = ["Het", "Slash", "Femslash", "Poly", "Enby", "Gen"];
export const SHIP_STATUSES = {
  Canon: { cls: "text-amber-200 bg-amber-500/15 border-amber-500/45", hex: "#f59e0b", abbr: "Ca" },
  Endgame: { cls: "text-rose-200 bg-rose-500/15 border-rose-500/45", hex: "#f43f5e", abbr: "En" },
  Fanon: { cls: "text-fuchsia-200 bg-fuchsia-500/15 border-fuchsia-500/45", hex: "#d946ef", abbr: "Fa" },
  Crackship: { cls: "text-lime-200 bg-lime-500/15 border-lime-500/45", hex: "#84cc16", abbr: "Cr" },
  Past: { cls: "text-stone-300 bg-stone-500/15 border-stone-500/45", hex: "#a8a29e", abbr: "Pa" },
};
export const STATUS_ORDER = Object.keys(SHIP_STATUSES);

export const CHARACTER_TYPES = ["Protagonist", "Deuteragonist", "Antagonist", "Supporting", "Minor", "Mentioned", "Original Character"];

export const HERO_IMG = "https://images.unsplash.com/photo-1567910640027-4029c4d8e9e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
export const MAP_IMG = "https://images.unsplash.com/photo-1520299607509-dcd935f9a839?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
